// tslint:disable:max-line-length
/**
 * Created by ddepaolis on 09/05/17.
 * CLDR required by Globalize
 *  check here to know what cldr data  to load
 * http://johnnyreilly.github.io/globalize-so-what-cha-want/#/?currency=false&date=false&message=true&number=false&plural=false&relativeTime=false&unit=false
 *  https://github.com/globalizejs/globalize#2-cldr-content
 * here we pass an array of json object containing all the localizations (in node we could use dynamic recquire but with webpack it doesnt work.  temp solution is hardcoding each require
 * to avoid aving to mess with the processor i put all the requires in a separate file.
 */

import { cldrJsonDataShared } from "./CLDRJsonShared";
import { cldrJsonDataEN } from "./CLDRJsonEN";
import { cldrJsonDataDE } from "./CLDRJsonDE";

// tslint:disable-next-line:variable-name
export const CLDRJSONData = [...cldrJsonDataEN, ...cldrJsonDataDE, ...cldrJsonDataShared];
